<div class="fs-2 with-close" mat-dialog-title>
    Votre numéro de téléphone
    <i class="fa fa-close" (click)="onNoClick()" aria-hidden="true"></i>
</div>
<div mat-dialog-content>
    <p>Pour être mis en relation avec le professionnel qui propose ce bien, indiquez le numéro sur lequel vous joindre.</p>
    <mat-form-field>
        <mat-label>Mobile</mat-label>
        <input matInput type="tel" [(ngModel)]="mobile" (ngModelChange)="error = ''" placeholder="06 12 34 56 78">
    </mat-form-field>
    <p class="text-danger mb-0" *ngIf="error">{{ error }}</p>
</div>
<div mat-dialog-actions>
    <button (click)="onNoClick()" type="reset" class="btn btn-outline">
        Annuler
    </button>
    <button (click)="onYesClick()" type="submit" class="btn btn-primary">
        <mat-spinner diameter="26" *ngIf="loading"></mat-spinner>
        <ng-container *ngIf="!loading">Valider</ng-container>
    </button>
</div>
